module.exports = __webpack_public_path__ + "static/media/login_logo_.7a52c2ba.png";